import { isDefined } from '../ramda';
import { isTextBlockDefined } from './isTextBlockDefined';
import { IFastFactItem } from './types';

/**
 * Checks whether Fast Fact item data is defined or it's empty
 * @param item - Fast Fact item data
 * @returns {*|boolean}
 */
export function isFastFactItemDefined(item: IFastFactItem) {
  const titleDefined = isDefined(item?.title);
  const descDefined = isTextBlockDefined(item?.desc);

  return titleDefined || descDefined;
}
